import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import myheader from "@/components/header";
import swiperNews from "@/components/swiperNews";
import newTypeCom from "@/components/newTypeCom";
import enterSICHUANG from "@/components/enterSICHUANG";
import footerCom from "@/components/footerCom";

// import { Options, Vue } from 'vue-class-component';
// import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

// @Options({
//   components: {
//     HelloWorld,
//   },
// })
// export default class Home extends Vue {}

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(myheader)),
    _createVNode(_unref(swiperNews), { style: {"margin":"15px"} }),
    _createVNode(_unref(enterSICHUANG)),
    _createVNode(_unref(newTypeCom), { style: {"margin":"auto","margin-top":"24px","margin-bottom":"24px"} }),
    _createVNode(_unref(footerCom))
  ]))
}
}

})